import {useSelector} from "react-redux";
import appstrore_en from '../images/appstrore-en.svg';
import google_play_en from '../images/google-play-en.svg';
import appstrore_ru from '../images/appstrore-ru.svg';
import google_play_ru from '../images/google-play-ru.svg';
import fb from '../images/fb.svg'
import tw from '../images/tw.svg'
import yt from '../images/yt.svg'
import s_in from '../images/in.svg'
import tg from '../images/tg.svg'
import vk from '../images/vk.svg'
import logo from "../images/logo.svg";
import en from "../images/en.svg";
import React from "react";
import {airtable_config_get_label} from "../redux/actions";

export const Footer = () => {
    const locale = useSelector(state => state.app.locale)
    const configData = useSelector(state => state.app.configData)
    const col_1_title = configData !== null ? airtable_config_get_label(configData, 'footer_col_1_title', locale) : null;
    const col_2_title = configData !== null ? airtable_config_get_label(configData, 'footer_col_2_title', locale) : null;
    const col_3_title = configData !== null ? airtable_config_get_label(configData, 'footer_col_3_title', locale) : null;
    const col_4_title = configData !== null ? airtable_config_get_label(configData, 'footer_col_4_title', locale) : null;
    const col_5_title = configData !== null ? airtable_config_get_label(configData, 'footer_col_5_title', locale) : null;
    if (configData === null) {
        return null;
    }
    return (
        <footer className="footer">
            <div className="container">
                <div className="container__wrap footer__flex">
                    <nav className="footer__menu footer__menu_1">
                        <div className="footer__heading">
                            {col_1_title}
                        </div>
                        <ul>
                            {
                                configData.map((item) => {
                                    if (item.fields.type === 'footer_menu_col_1' && item.fields.locale === locale) {
                                        return (
                                            <li key={item.fields.id}>
                                                <a href={item.fields.link} target="_blank" rel="noopener">
                                                    {item.fields.label}
                                                </a>
                                            </li>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </ul>
                    </nav>
                    <nav className="footer__menu footer__menu_2">
                        <div className="footer__heading">
                            {col_2_title}
                        </div>
                        <ul>
                            {
                                configData.map((item) => {
                                    if (item.fields.type === 'footer_menu_col_2' && item.fields.locale === locale) {
                                        return (
                                            <li key={item.fields.id}>
                                                <a href={item.fields.link} target="_blank" rel="noopener">
                                                    {item.fields.label}
                                                </a>
                                            </li>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </ul>
                    </nav>
                    <nav className="footer__menu footer__menu_3">
                        <div className="footer__heading">
                            {col_3_title}
                        </div>
                        <ul>
                            {
                                configData.map((item) => {
                                    if (item.fields.type === 'footer_menu_col_3' && item.fields.locale === locale) {
                                        return (
                                            <li key={item.fields.id}>
                                                <a href={item.fields.link} target="_blank" rel="noopener">
                                                    {item.fields.label}
                                                </a>
                                            </li>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </ul>
                    </nav>
                    <nav className="footer__menu footer__menu_4">
                        <div className="footer__heading">
                            {col_4_title}
                        </div>
                        <ul>
                            {
                                configData.map((item) => {
                                    if (item.fields.type === 'footer_menu_col_4' && item.fields.locale === locale) {
                                        return (
                                            <li key={item.fields.id}>
                                                <a href={item.fields.link} target="_blank" rel="noopener">
                                                    {item.fields.label}
                                                </a>
                                            </li>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </ul>
                    </nav>
                    <div className="footer__apps">
                        <div className="footer__heading">
                            {col_5_title}
                        </div>
                        <div className="footer__apps_links">
                            {
                                configData.map((item) => {
                                    if (item.fields.id === 'footer_appstrore' && item.fields.locale === locale) {
                                        return (
                                            <a href={item.fields.link} key={item.fields.id} target="_blank"
                                               rel="noopener">
                                                {
                                                    locale === 'en' && (
                                                        <img src={appstrore_en} alt={item.fields.label}
                                                             title={item.fields.label}/>)
                                                }
                                                {
                                                    locale === 'ru' && (
                                                        <img src={appstrore_ru} alt={item.fields.label}
                                                             title={item.fields.label}/>)
                                                }
                                            </a>
                                        )
                                    }
                                    return null;
                                })
                            }
                            {
                                configData.map((item) => {
                                    if (item.fields.id === 'footer_google_play' && item.fields.locale === locale) {
                                        return (
                                            <a href={item.fields.link} key={item.fields.id} target="_blank"
                                               rel="noopener">
                                                {
                                                    locale === 'en' && (
                                                        <img src={google_play_en} alt={item.fields.label}
                                                             title={item.fields.label}/>)
                                                }
                                                {
                                                    locale === 'ru' && (
                                                        <img src={google_play_ru} alt={item.fields.label}
                                                             title={item.fields.label}/>)
                                                }
                                            </a>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="container__wrap footer__flex_2">
                    {
                        configData.map((item) => {
                            if (item.fields.id === 'logo' && item.fields.locale === locale) {
                                return (
                                    <a href={item.fields.link} key={item.fields.id} className="footer__logo"
                                       target="_blank" rel="noopener">
                                        <img src={logo} alt={item.fields.label} title={item.fields.label}/>
                                    </a>
                                )
                            }
                            return null;
                        })
                    }

                    <div className="footer__social">
                        {

                            configData.map((item) => {
                                if (item.fields.type === 'footer_soc' && item.fields.locale === locale) {
                                    let cl = item.fields.label.trim();

                                    return (
                                        <a href={item.fields.link} key={item.fields.id} target="_blank"
                                           rel="noopener">
                                            {
                                                cl === 'fb' &&
                                                (<span className="fb" style={{maskImage: `url(${fb})`, WebkitMaskImage: `url(${fb})`}}/>)
                                            }
                                            {cl === 'tw' &&
                                            <span className="tw"
                                                  style={{maskImage: `url(${tw})`, WebkitMaskImage: `url(${tw})`}}/>}
                                            {cl === 'yt' &&
                                            <span className="yt"
                                                  style={{maskImage: `url(${yt})`, WebkitMaskImage: `url(${yt})`}}/>}
                                            {cl === 'in' &&
                                            <span className="in" style={{
                                                maskImage: `url(${s_in})`,
                                                WebkitMaskImage: `url(${s_in})`
                                            }}/>}
                                            {cl === 'tg' &&
                                            <span className="tg"
                                                  style={{maskImage: `url(${tg})`, WebkitMaskImage: `url(${tg})`}}/>}
                                            {cl === 'vk' &&
                                            <span className="vk"
                                                  style={{maskImage: `url(${vk})`, WebkitMaskImage: `url(${vk})`}}/>}
                                        </a>
                                    )
                                }
                                return null;
                            })
                        }
                    </div>
                    {
                        configData.map((item) => {
                            if (item.fields.id === 'footer_copyright' && item.fields.locale === locale) {
                                return (
                                    <div key={item.fields.id} className="footer__copyright">
                                        {item.fields.label}
                                    </div>
                                )
                            }
                            return null;
                        })
                    }
                    {
                        locale === 'ru' && (
                            <div className="footer__switch_lang" onClick={() => {
                                window.location.href = '/' + window.location.search;
                            }}>
                                Switch to English <img src={en} alt="" title=""/>
                            </div>
                        )
                    }
                </div>

            </div>
        </footer>

    )
}